<template>
  <div class="dictInfo">
    <Modal
      title="字典详情"
      v-model="modalView"
      @on-visible-change="changeVisible"
      :mask-closable="false"
      width="750"
      footer-hide
      class="dictInfo-modal"
    >
      <div class="flexfs flexwarp">
        <div class="infokv form50 mt-0">
          <label>类型名称：</label>
          <div>{{ form.itemName }}</div>
        </div>
        <div class="infokv form50 mt-0">
          <label>类型编码：</label>
          <div>{{ form.type }}</div>
        </div>
        <div  v-if="form.type=='SERVICE_NUM'" class="infokv form50 mt-0">
          <label>默认数量：</label>
          <div>{{ JSON.parse(form.extdata).defaultNum||0 }}</div>
        </div>
        <div class="infokv form100 mt-0">
          <label>包含子项：</label>
          <div>
            <Tag
              size="medium"
              color="blue"
              v-for="(item, index) in form.tag"
              :key="item.itemValue"
              class="mr-16 mb-16"
              >{{ item.itemName }} ({{ item.itemValue }})</Tag
            >
            <span v-if="form.tag.length===0">暂无子项</span>
          </div>
        </div>
      </div>
      <div class="flexend">
        <Button class="btn104 mr-16" shape="circle" @click="cancle"
          >关闭</Button
        >
        <!-- <Button class="btn104" type="primary" shape="circle" @click="cancle"
          >确定</Button
        > -->
      </div>
    </Modal>
  </div>
</template>

<script>
import { putItem } from "@/api/system";

export default {
  name: "",
  components: {},
  props: {
    form: Object,
    dialog: Boolean,
  },
  data() {
    return {
      loading: false,
      modalView: false,
    };
  },
  created() {
    this.modalView = true;
  },
  methods: {
    cancle() {
      this.modalView = false;
    },
    changeVisible(val) {
      this.modalView = false;
      if (!val) {
        this.$emit("update:dialog", false);
      }
    },
  },
};
</script>

<style lang="scss">
.dictInfo-modal {
  .ivu-tag {
    margin: 0 12px 16px 0;
  }
}
</style>
